__turbopack_context__.v({
  "closeButton": "MediaLightbox-module-scss-module__Xqe7bG__closeButton",
  "header": "MediaLightbox-module-scss-module__Xqe7bG__header",
  "mainImage": "MediaLightbox-module-scss-module__Xqe7bG__mainImage",
  "mainImageWrapper": "MediaLightbox-module-scss-module__Xqe7bG__mainImageWrapper",
  "navButton": "MediaLightbox-module-scss-module__Xqe7bG__navButton",
  "overlay": "MediaLightbox-module-scss-module__Xqe7bG__overlay",
  "thumbnail": "MediaLightbox-module-scss-module__Xqe7bG__thumbnail",
  "thumbnailActive": "MediaLightbox-module-scss-module__Xqe7bG__thumbnailActive",
  "thumbnails": "MediaLightbox-module-scss-module__Xqe7bG__thumbnails",
  "viewer": "MediaLightbox-module-scss-module__Xqe7bG__viewer",
});
